import callToLogin from "@/assets/imgs/call-to-login.png";
import { useClientTranslations } from "@/lib/translate";
import { routes } from "@/lib/utils/routes";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { Cancel01Icon } from "hugeicons-react";
import Image from "next/image";
import Link from "next/link";
import React from "react";

const AICallLoginPopup = ({
  openLoginModal,
  onCloseLoginModal,
}: {
  openLoginModal: boolean;
  onCloseLoginModal: () => void;
}) => {
  const { t: tJobApply } = useClientTranslations("job-apply");

  return (
    <Dialog
      open={openLoginModal}
      as="div"
      className="relative z-10 focus:outline-none"
      onClose={onCloseLoginModal}
    >
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-black/40 backdrop-blur-sm transition-all duration-300">
        <div className="flex min-h-full items-center justify-center p-4">
          <DialogPanel className="w-full max-w-md rounded-2xl bg-gradient-to-br max-h-[80vh] overflow-y-auto mt-7 from-primary via-primary/80 to-primaryDark p-8 shadow-2xl backdrop-blur-2xl relative overflow-hidden">
            {/* Close Button */}
            <button
              onClick={onCloseLoginModal}
              className="absolute top-4 right-4 z-20 p-2 rounded-full bg-white/20 hover:bg-white/30 text-white hover:text-white/90 transition-all duration-200 shadow-lg hover:shadow-xl"
              aria-label="Close modal"
            >
              <Cancel01Icon className="w-5 h-5" />
            </button>

            {/* Illustration */}
            <div className="flex justify-center mb-4 animate-fade-in">
              <Image
                src={callToLogin}
                width={1000}
                height={1000}
                alt="Create Profile"
                className="w-28 h-28 object-contain drop-shadow-xl rounded"
              />
            </div>
            <DialogTitle
              as="h3"
              className="text-2xl font-extrabold text-white mb-2 text-center drop-shadow-lg"
            >
              {tJobApply("loginToGenSuggestionTitle")}
            </DialogTitle>
            <p className="mt-2 text-base text-white/90 text-center mb-4">
              {tJobApply("loginToGenSuggestionDesc")}
              <br />
              <span className="font-semibold text-white/95">
                {tJobApply("loginToGenSuggestionDesc2")}
              </span>
            </p>
            {/* Benefits List */}
            <ul className="mb-6 mt-2 space-y-2">
              <li className="flex items-center gap-2 text-white/90 text-base">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/20 text-white text-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </span>
                {tJobApply("featurePersonalizedSuggestion")}
              </li>
              <li className="flex items-center gap-2 text-white/90 text-base">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/20 text-white text-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 16l4-4m0 0l-4-4m4 4H7"
                    />
                  </svg>
                </span>
                {tJobApply("featureApply")}
              </li>
              <li className="flex items-center gap-2 text-white/90 text-base">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/20 text-white text-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-5 h-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </span>
                {tJobApply("featureSave")}
              </li>
            </ul>
            <div className="mt-6 flex flex-col items-center gap-3">
              <Link
                href={routes.auth.login}
                className="inline-flex items-center gap-2 rounded-lg bg-white px-7 py-3 text-lg font-bold text-primary shadow-inner shadow-white/10 hover:bg-gray-100 focus:outline-none transition-all duration-200 animate-pulse hover:scale-105"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {tJobApply("loginToGenSuggestionCallToAction")}
              </Link>
              {/* Optionally, add a secondary action */}
              {/* <button className="text-white/80 underline text-sm hover:text-white/95 transition-colors">Learn more</button> */}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

AICallLoginPopup.displayName = "AICallLoginPopup";
export default AICallLoginPopup;
